export default __webpack_public_path__ + "static/footer-background-d7ffdd3083d239776184e2da02073d03.png";